import type { TxOverview } from '../logic/createTxOverview'
import { SPK_STAKING_POINTS_MULTIPLIER } from '@/config/consts'
import { Token } from '@/domain/types/Token'
import { formatTimeLeft } from '@/features/spk/staking/utils/formatTimeLeft'
import { assets } from '@/ui/assets'
import { HorizontalScroll } from '@/ui/atoms/horizontal-scroll/HorizontalScroll'
import { TransactionOverview } from '@/ui/organisms/transaction-overview/TransactionOverview'
import { testIds } from '@/ui/utils/testIds'

interface StakeTransactionOverviewProps {
  txOverview: TxOverview
  selectedToken: Token
}

function StakeTransactionOverview({ txOverview }: StakeTransactionOverviewProps) {
  if (txOverview.status !== 'success') {
    const placeholder = '-'

    return (
      <TransactionOverview>
        <TransactionOverview.Row>
          <TransactionOverview.Label>Rewards</TransactionOverview.Label>
          <TransactionOverview.Generic>{placeholder}</TransactionOverview.Generic>
        </TransactionOverview.Row>
        <TransactionOverview.Row>
          <TransactionOverview.Label>Unstaking delay</TransactionOverview.Label>
          <TransactionOverview.Generic>{placeholder}</TransactionOverview.Generic>
        </TransactionOverview.Row>
      </TransactionOverview>
    )
  }
  const { unstakingDelay } = txOverview

  return (
    <TransactionOverview>
      <TransactionOverview.Row>
        <TransactionOverview.Label>Rewards</TransactionOverview.Label>
        <HorizontalScroll>
          <TransactionOverview.Generic>
            <div className="flex items-center gap-1">
              <img src={assets.points.pointsIcon} className="size-4" />
              <div className="typography-label-2 text-primary">{SPK_STAKING_POINTS_MULTIPLIER}x Spark Points</div>
            </div>
          </TransactionOverview.Generic>
        </HorizontalScroll>
      </TransactionOverview.Row>
      <TransactionOverview.Row>
        <TransactionOverview.Label>Unstaking delay</TransactionOverview.Label>
        <TransactionOverview.Generic data-testid={testIds.spkStaking.stakeDialog.transactionOverview.unstakingDelay}>
          {formatTimeLeft(unstakingDelay)}
        </TransactionOverview.Generic>
      </TransactionOverview.Row>
    </TransactionOverview>
  )
}

export {
  StakeTransactionOverview as TransactionOverview,
  type StakeTransactionOverviewProps as TransactionOverviewProps,
}
